/**************************************************
 * Nombre:       Home_Contactos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import ic_locacion from "../../../Recursos/ic_locacion.svg"
import ic_telefonos from "../../../Recursos/ic_telefonos.svg"
import ic_mail from "../../../Recursos/ic_mail.svg"
import {irUrl} from "../../../Utilidades/irUrl";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {CONTACTOS} from "../../../Constantes";

const Home_Contactos = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: 'white'}}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pt: 12, pb: 8, }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={sCell ? 'center' : 'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 2 : 0}
                    >

                        {CONTACTOS.map((item, index) => (
                            <Grid container size={{xs: 6, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Grid
                                    container
                                    justifyContent={'center'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    spacing={0}
                                >

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'center', height: 110, alignItems: 'center'}}>
                                        <img src={item.img} width={'auto'} height={sCell ? item.alto - 20 : item.alto}/>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'center', mt: 2}}>
                                        <Typography sx={{fontSize: 24, fontWeight: 800}}>{item.nombre}</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 8}}
                                          sx={{justifyContent: 'center', height: 60}}>
                                        <Typography
                                            sx={{textAlign: 'center', lineHeight: 1.2}}>{item.descripcion}</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'center', mt: 2}}>
                                        <Button
                                            onClick={() => irUrl(item.link)}
                                            sx={{fontSize: 16}}>{item.accion}</Button>
                                    </Grid>

                                </Grid>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Contactos



